// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Atom_Cta from "./Atom_Cta.bs.js";
import * as User_Provider from "../../user/User_Provider.bs.js";
import * as User_Observable from "../../user/User_Observable.bs.js";

function Atom_SubscribeButton(Props) {
  var dsId = Props.dsId;
  var availabilityOpt = Props.availability;
  var availability = availabilityOpt !== undefined ? availabilityOpt : "NotAvailable";
  var match = Context.I18n.getState(undefined);
  var labels = match.labels;
  var userStatus = Curry._1(User_Provider.Hook.useUserStatus, undefined);
  var match$1 = Curry._1(User_Observable.Magazine.Magazine.Hook.use, dsId);
  var remove = match$1.remove;
  var add = match$1.add;
  if (availability === "NotAvailable" || userStatus >= 2) {
    return null;
  } else if (match$1.status) {
    return React.createElement(Atom_Cta.Button.make, {
                label: labels.common.subscribed,
                onClick: (function (param) {
                    Curry._1(remove, undefined);
                  }),
                style: /* Unsubscribe */33
              });
  } else {
    return React.createElement(Atom_Cta.Button.make, {
                label: labels.common.subscribe,
                onClick: (function (param) {
                    Curry._1(add, undefined);
                  }),
                style: /* Subscribe */24
              });
  }
}

var make = Atom_SubscribeButton;

export {
  make ,
}
/* react Not a pure module */
